import React from 'react';
import styled from 'styled-components';
import theme from '../theme';
import fn from '../../helpers/fn';

export default fn(__filename, styled.div`
  ${({ horizontal, large }) => !horizontal && `
    padding-top: ${theme.unit * (large ? 4 : 2)}px;
    padding-bottom: ${theme.unit * (large ? 4 : 2)}px;
  `}
  ${({ vertical, large }) => !vertical && `
    padding-left: ${theme.unit * (large ? 4 : 2)}px;
    padding-right: ${theme.unit * (large ? 4 : 2)}px;

    @media screen and (max-width: 640px) {
      padding-left: ${theme.unit * (large ? 2 : 1)}px;
      padding-right: ${theme.unit * (large ? 2 : 1)}px;
    }
  `}

  ${({ flex }) => flex && `
    flex: ${flex};
  `}

  ${({ height }) => height && `
    height: ${height};
    box-sizing: border-box;
  `}

  ${({ border }) => border && `
    border: solid ${typeof border === 'number' ? border : 3}px ${theme.colors.gray18};
    border-radius: ${theme.unit}px;
  `}

  ${({ minWidth }) => minWidth && `
    min-width: ${minWidth}px;
  `}

  ${({ center }) => center && `
    text-align: center;
  `}
`.withComponent(({
  horizontal, vertical, flex, height, border, minWidth, center, // strip
  ...props
}) => <div {...props} />));



// WEBPACK FOOTER //
// ./src/components/blocks/Block.js